import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 환자의 금주 일지 조회
// request data
//  - pid
//  - start => YYYYMMDD
//  - end => YYYYMMDD
function getDoNotDrinkDiaryFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/journal',
        method: 'get',
        params: request
    })
}

export default getDoNotDrinkDiaryFromAlcohol;